export const isEnabled = function (player, item) {
  return player.src() === item.src
}
